import React from "react";

export default function Stat({ label, value, hint, children }) {
  return (
    <div className="stl-card stl-stat">
      <span className="stl-stat__label">{label}</span>
      <span className="stl-stat__value">{value}</span>
      {hint && <span className="stl-stat__hint">{hint}</span>}
      {children}
    </div>
  );
}
